import { Controller } from "@hotwired/stimulus"

// Ticks a live elapsed counter once a second.
//
// The run page reconciles with the server every 10s (predict-auto-refresh
// Turbo-visits the URL), which is what keeps step *statuses* honest. But the
// elapsed numbers came from that same render, so they sat frozen and then
// jumped ten seconds at a time — on a step that runs 20 minutes, the page
// looked stuck. This counts locally between reconciles so the number moves
// every second, and each refresh re-seeds it from the server's own clock, so
// drift can never accumulate.
//
//   <span data-controller="predict-elapsed"
//         data-predict-elapsed-start-value="<%= step.started_at.to_i %>">
//     2m 6s
//   </span>
export default class extends Controller {
  static values = {
    // Unix seconds, server-rendered. The server's clock is the source of
    // truth; the browser's only interpolates between refreshes.
    start: Number,
  }

  connect() {
    if (!this.hasStartValue || !this.startValue) return

    // Offset between the two clocks, measured once: the element's initial
    // text is the server's elapsed figure at render time. Interpolating from
    // the raw browser clock instead would show a jump on every page whose
    // viewer's clock is skewed.
    this.clientStart = Date.now()
    this.serverElapsed = Math.max(0, Math.floor(Date.now() / 1000) - this.startValue)

    this.timer = setInterval(() => this.tick(), 1000)
    this.tick()
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
    this.timer = null
  }

  tick() {
    const drift = Math.floor((Date.now() - this.clientStart) / 1000)
    this.element.textContent = this.format(this.serverElapsed + drift)
  }

  // Mirrors Predict::UiHelper#format_duration so a tick never restyles the
  // value the server just rendered.
  format(totalSeconds) {
    const seconds = Math.max(0, totalSeconds)
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = seconds % 60

    const parts = []
    if (hours > 0) parts.push(`${hours}h`)
    if (minutes > 0 || hours > 0) parts.push(`${minutes}m`)
    parts.push(`${secs}s`)
    return parts.join(" ")
  }
}
